import React, { useEffect, useState } from "react";
import { MainHeaderMenu } from "../../data/menu";
import { footerData } from "../../data/footer/footer";
import CookieBanner from "../model/CookieModal";
import MobileNavigation from "./Navigation/mobileNavigation";
import WebNavigation from "./Navigation/webNavigation";
import Footer from "./Footer";
import { useLocation } from "@reach/router";
import { checkPageLevel } from "../../utilities/text";
import {
  getToken,
  setToken,
  setLastVisitedPage,
  getUser,
  getLastVisitedPage,
  getUserType,
  dashBoardPath,
  setUser,
  setServiceList,
} from "../../services/CurrentUser/currentUserLocalStorage";
import { handleAuthorization } from "../../services/users";
import {
  redirectToLoginPage,
  redirectToLoginPageFromLogout,
} from "../../utilities/redirect-to-login";
import {
  getUsersDefaultService,
  getInitials,
  getHasLoginStatus,
} from "../../utilities/account-service-utils";
import { UserSignedContext } from "../../context/UserSignedContext";
import TERi from "../model/TERi";
import { getData } from "../../services/users.js";
import { formatJSON, sanitizeUserData } from "../../utilities/text.utils.js";
// import {findServiceType} from "../../utilities/account-service-utils.js"

const Index = ({
  children,
  hasBreadCrumbs,
  requiresLogin = false,
  pageView = "",
}) => {
  const isBrowser = typeof window !== "undefined";

  const signedIn = getHasLoginStatus();
  const userType = getUserType();
  const dashBoardUrl = dashBoardPath(userType);
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [userIsSigned, setUserIsSignIned] = useState(signedIn);
  // const [userProfileImage, setuserProfileImage] = useState("");
  const [useInitials, setUseInitials] = useState("");

  // const userProfileImage = defaultService?.DisplayImageUrl;
  // const useInitials =
  //   !userProfileImage && getInitials(defaultService?.DisplayName);

  const page = checkPageLevel(location.pathname);
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment !== "");

  useEffect(() => {
    getData().then((res) => {
      // console.log("getData call in website layout", res);

      if (res?.data?.length) {
        const { data } = formatJSON(res) || {};
        if (data) {
          const { serviceList, hasLogin, token, user_Id, user } =
            sanitizeUserData(data);

          setUseInitials(getInitials(user?.DisplayName));
          setUserIsSignIned(hasLogin);
          if (isBrowser) {
            const userToStore = {
              ContactEmail: user?.ContactEmail,
              ContactPhone: user?.ContactPhone,
              DefaultServiceID: user?.ID,
              DisplayName: user?.DisplayName,
              FirstName: user?.FirstName,
              LastName: user?.LastName,
              SecondaryID: user?.SecondaryID,
              msisdn: serviceList[0].primaryID,
              primaryID: user?.primaryID,
              serviceType: user?.Type,
              username: user_Id,
            };
            localStorage.setItem("hasLogin", hasLogin);
            setToken(token);
            setUser(userToStore);
            setServiceList({
              serviceList: serviceList,
            });
          }
        } else {
          if (isBrowser) localStorage.removeItem("hasLogin");
          setUseInitials("");
          setUserIsSignIned(false);
          setServiceList({});
          setToken("");
          setUser({});
        }
      } else {
        if (isBrowser) localStorage.removeItem("hasLogin");
        setUseInitials("");
        setUserIsSignIned(false);
        setServiceList({});
        setToken("");
        setUser({});
      }
    });
  }, []);

  useEffect(() => {
    if (requiresLogin) {
      // get token from local storage
      const token = getToken();
      if (token) {
        handleAuthorization(token)
          .then((result) => {
            // if authorized allow update state to allow children
            if (result.success) {
              setIsAuthorized(true);
            }
            // if unauthorized navigate to login page
            if (!result.success) {
              redirectToLoginPage();
            }
          })
          .catch((error) => {
            // if error play it safe and navigate to login page
            // console.log(error);
            redirectToLoginPage();
          });
      } else {
        // if no token exists navigate to login page
        const userIsSigned = getHasLoginStatus();
        if (userIsSigned) {
          setIsAuthorized(true);
          return;
        } // is possibly enterprise login
        redirectToLoginPage();
      }
    } else {
      // console.log("NOT AN MVW PAGE");
    }
  }, [requiresLogin, pageView]);

  const authorizedToViewPage = requiresLogin ? isAuthorized : true;

  // console.log("LAST VISITED", getLastVisitedPage());
  return (
    <>
      <MobileNavigation
        menuData={MainHeaderMenu}
        PageLevel={page}
        useInitials={useInitials}
        // userProfileImage={userProfileImage}
        userIsSigned={userIsSigned}
        handleUserLogout={redirectToLoginPageFromLogout}
        dashBoardUrl={dashBoardUrl}
        userType={userType}
      />
      <WebNavigation
        menuData={MainHeaderMenu}
        PageLevel={page}
        hasBreadCrumbs={hasBreadCrumbs}
        urlPathName={location.pathname}
        pathSegments={pathSegments}
        useInitials={useInitials}
        // userProfileImage={userProfileImage}
        userIsSigned={userIsSigned}
        handleUserLogout={redirectToLoginPageFromLogout}
        userType={userType}
        dashBoardUrl={dashBoardUrl}
      />
      <div
        className={`layout-container ${
          hasBreadCrumbs ? "pt-15 md:pt-55" : "pt-20 md:pt-39"
        } overflow-x-hidden`}
      >
        {/* {children} */}
        {authorizedToViewPage && children}
      </div>
      <TERi />
      <Footer footerData={footerData} />
      <CookieBanner />
    </>
  );
};

export default Index;
